






















import sizeable from '../../mixins/sizeable/sizeable';
import mixins from '../../mixins';
import PTab from './p-tab.vue';
import PChild from '../p-parent/p-child.vue';

type ChildType = InstanceType<typeof PChild>;
type TabType = InstanceType<typeof PTab>;

export default mixins(sizeable).extend({
  props: {
    value: { default: undefined, type: [Number, String] },
    color: { default: 'interaction', type: String },
    colorActive: { default: 'positive', type: String },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value !== undefined && this.value !== null) {
          this.$set(this, 'selectedTabIndex', this.value);
        }
        this.selectedTabIndex = this.selectedTabIndex ?? 0;
      },
    },
    selectedTabIndex: {
      immediate: true,
      handler() {
        // Wait a tick, dependent on value being set first etc
        this.$nextTick(() => {
          const selectedIndex = this.selectedTabIndex;
          if (!Array.isArray(this.tabs)) {
            // If no child p-tabs inside slot
            return;
          }
          this.tabs.forEach((tab: ChildType) => {
            if ((tab?.$parent as any)?.internalActive) {
              this.$set(tab.$parent, 'internalActive', false);
              tab?.$el?.classList.remove('p-tab-active');
            }
          });
          if (selectedIndex !== undefined) {
            const tab = this.tabs[selectedIndex];
            tab?.$el?.classList.add('p-tab-active');
            this.$emit('input', selectedIndex);
            if (tab) {
              this.$set(tab?.$parent, 'internalActive', true);
            }
          }
        });
      },
    },
  },
  methods: {
    getClassList(tab: ChildType, active: boolean): any {
      const disabled = (tab.$parent as TabType).$props.disabled as boolean;
      return {
        'p-tab': true,
        active,
        [`color-${this.color}`]: !active && !disabled,
        [`color-${this.colorActive}`]: active && !disabled,
        'color-disabled': disabled,
        disabled,
        dense: this.dense,
        spacious: this.spacious,
      };
    },
    clickOnTab(index: number, tab: ChildType, toggle: ()=>{}) {
      if (this.getTabDisabled(tab)) {
        return;
      }
      this.$emit('click', index);
      toggle();
    },
    getTabDisabled(tab: ChildType) {
      if (!tab.$parent) {
        return true;
      }
      if (!tab.$parent.$props) {
        return true;
      }
      return (tab.$parent as TabType).$props.disabled;
    },
    renderLabel(tab: TabType) {
      if (!tab.$parent) {
        return 'Tab undefined';
      }
      if (!tab.$parent.$props) {
        return 'Tab props undefined';
      }
      return tab.$parent.$props.label;
    },
  },
  data: () => ({
    tabs: [] as ChildType[],
    selectedTabIndex: undefined as number | undefined,
  }),
});
